import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {IconButton, Avatar, Tooltip} from '@material-ui/core';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockIcon from '@material-ui/icons/Lock';
import '../utils/mystyle.module.css'
import Badge from '@material-ui/core/Badge';



const useStyles = makeStyles((theme) => ({
  root: {
    display:"inline",
  },
  selected: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    
  },
  unselected: {
    width: theme.spacing(8),
    height: theme.spacing(8),
     },
  
}));


export const MaterialSwatch = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  const [lock, setlock] = useState(false);
  const classes = useStyles();
  const {keys, name,  source, idx,mousOnMaterials,resetLock, setResetLock} = props;

  function addLock() {
    setIsHovered(true)
  }
  
  function removeLock() {
    setIsHovered(false)
  }

  useEffect(() => {
      if(!mousOnMaterials){
        setIsHovered(false)
      }
  },[mousOnMaterials])

  useEffect(() => {
      if(resetLock===true){
        setlock(false);
        setResetLock(false)
      }
  },[resetLock]) // from material menue

  const onChange = (event) => {
    if (lock !== false){
      setlock(false);
    }
    else{
      setlock(true)
    }

  }

  return (
    <div className={classes.root} id={keys} >
      <Tooltip title={name} arrow>
        <IconButton size="medium" id={idx} onClick={onChange} onMouseEnter={addLock} onMouseLeave={removeLock} >
          {isHovered ?
          // if hovered option to lock
            
            lock ? 
            <Badge badgeContent={<LockIcon/>} >
              <Avatar alt={name} src={source}  className={classes.unselected} style={{ border: '0.1px solid lightgray' }}/>
            </Badge>
            :
            
            <Badge badgeContent={<LockOpenIcon/>} >
              <Avatar alt={name} src={source}  className={classes.unselected} style={{ border: '0.1px solid lightgray' }}/>
            </Badge>
            
            :
            //if not hovered check if it has been activated
            lock ? 
              <Badge badgeContent={<LockIcon/>} >
                <Avatar alt={name} src={source}  className={classes.unselected} style={{ border: '0.1px solid lightgray' }}/>
              </Badge>
            :
              
                <Avatar alt={name} src={source}  className={classes.unselected} style={{ border: '0.1px solid lightgray' }}/>
            
            
          }
        </IconButton>
      </Tooltip>
    </div>
  );
}

export default MaterialSwatch;